<template>
    <label class="el-radio ovr-radio"
           :class="[
      border && radioSize ? 'el-radio--' + radioSize : '',
      { 'is-disabled': isDisabled },
      { 'is-focus': focus },
      { 'is-bordered': border },
      { 'is-checked': model == label }
    ]"
           role="radio"
           :aria-checked="model == label"
           :aria-disabled="isDisabled"
           :tabindex="tabIndex"
           @keydown.space.stop.prevent="model = label">
        <span class="el-radio__input"
              :class="{'is-disabled': isDisabled,
                        'is-checked': model == label,
                        'isWhite': isWhite}">
            <span class="ovr-radio__inner" :class="isWhiteClass"></span>
            <input class="el-radio__original"
                   :value="label"
                   type="radio"
                   v-model="model"
                   @focus="focus = true"
                   @blur="focus = false"
                   @change="handleChange"
                   :name="name"
                   :disabled="isDisabled"
                   tabindex="-1">
        </span>
        <span class="ovr-radio__label" :class="getLabelClass">
            <slot></slot>
            <template v-if="!$slots.default">
                {{label}}
            </template>
        </span>
    </label>
</template>
<style scoped>
    .ovr-radio {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .el-radio__input.is-checked .ovr-radio__inner {
        background-color: #f7b64c;
        border: 2px solid #f7b64c;
    }

    .ovr-radio__inner {
        border: 2px solid #f7b64c;
        border-radius: 100%;
        width: 20px;
        height: 20px;
        background-color: #fff;
        position: relative;
        cursor: pointer;
        display: inline-block;
        box-sizing: border-box;
    }

    .el-radio__input.is-checked .ovr-radio__inner.isWhite {
        background-color: #ffffff;
        border: 2px solid #ffffff;
    }

    .ovr-radio__inner.isWhite {
        border: 2px solid #ffffff;
        background-color: inherit;
    }
    .ovr-radio__label {
        color: white;
        text-align: start;
        padding: 4px 12px 0px 15px;
        border-radius: 20px;
        display: inline;
        margin-left: 5px;

        word-break: break-word;
        max-width: 200px;
        width: 100%;
        display: inline-block;
        height: auto;
        white-space: pre-wrap;
        padding-bottom: 4px;
    }

    .label-background {
        background-color: #f7b64c;
    }
</style>
<script>
    import Emitter from '../el-mixins/emitter';

    export default {
        name: 'ElRadio',

        mixins: [Emitter],

        inject: {
            elForm: {
                default: ''
            },

            elFormItem: {
                default: ''
            }
        },

        componentName: 'ElRadio',

        props: {
            value: {},
            label: {},
            disabled: Boolean,
            name: String,
            border: Boolean,
            size: String,
            inputStyle: {},
            labelBackground: Boolean,
            isWhite: Boolean
        },

        data()
        {
            return {
                focus: false
            };
        },
        computed: {
            isGroup()
            {
                let parent = this.$parent;
                while (parent)
                {
                    if (parent.$options.componentName !== 'ElRadioGroup')
                    {
                        parent = parent.$parent;
                    } else
                    {
                        this._radioGroup = parent;
                        return true;
                    }
                }
                return false;
            },
            getLabelClass()
            {
                if (this.labelBackground)
                {
                    return "label-background";
                } else
                {
                    return ""
                }
            },
            isWhiteClass()
            {
                if (this.isWhite)
                {
                    return "isWhite";
                } else
                {
                    return ""
                }
            },
            model: {
                get()
                {
                    return this.isGroup ? this._radioGroup.value : this.value;
                },
                set(val)
                {
                    if (this.isGroup)
                    {
                        this.dispatch('ElRadioGroup', 'input', [val]);
                    } else
                    {
                        this.$emit('input', val);
                    }
                }
            },
            _elFormItemSize()
            {
                return (this.elFormItem || {}).elFormItemSize;
            },
            radioSize()
            {
                const temRadioSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
                return this.isGroup
                    ? this._radioGroup.radioGroupSize || temRadioSize
                    : temRadioSize;
            },
            isDisabled()
            {
                return this.isGroup
                    ? this._radioGroup.disabled || this.disabled || (this.elForm || {}).disabled
                    : this.disabled || (this.elForm || {}).disabled;
            },
            tabIndex()
            {
                return !this.isDisabled ? (this.isGroup ? (this.model === this.label ? 0 : -1) : 0) : -1;
            }
        },

        methods: {
            handleChange()
            {
                this.$nextTick(() =>
                {
                    this.$emit('change', this.model);
                    this.isGroup && this.dispatch('ElRadioGroup', 'handleChange', this.model);
                });
            }
        }
    };
</script>
